import * as React from "react";
const SvgChat20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M5.84 6.875a1.322 1.322 0 1 1-2.644 0 1.322 1.322 0 0 1 2.645 0Zm3.816 0a1.322 1.322 0 1 1-2.645 0 1.322 1.322 0 0 1 2.645 0Zm2.492 1.323a1.322 1.322 0 1 0 0-2.645 1.322 1.322 0 0 0 0 2.645Z"
    }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 .833h16.667v12.5H9.583L3.333 17.5v-4.167H0V.833ZM1.667 2.5v9.167H5v2.5l3.75-2.5H15V2.5H1.667Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M10.417 15.833h-1.25v-1.666h2.083l3.75 2.5v-2.5h3.333V5H17.5V3.333H20v12.5h-3.333V20l-6.25-4.167Z"
    })
  );
export default SvgChat20Px;
